module.exports = __webpack_public_path__ + "static/order-2257ffa80b89a4fcfcf8666363a9f0e0.mp4";